export default {
  orderStatus: {
    0: 'Ha enviado el pedido. Por favor, espere a que el agente de compras reciba el pedido',
    23: 'El agente de compras ha recibido el pedido y está en contacto con el comerciante',
    22: 'Se ha pedido su mercancía. Número de transacción: ',
    5: 'El comerciante ha enviado el pedido. Método de envío: ',
    10: 'Su producto ha llegado al Almacén designado por acbuy',
    16: 'Su solicitud de devolución ha sido enviada. Por favor, espere mientras su agente la procesa',
    17: 'Su solicitud de reemplazo ha sido enviada. Por favor, espere mientras su agente la procesa',
    buyerReturn:
      'El agente ha enviado una solicitud de devolución debido a necesidades del cliente, riesgos del artículo, etc. Por favor, espere mientras se procesa',
    buyerReplace:
      'El agente ha enviado una solicitud de reemplazo debido a necesidades del cliente, riesgos del artículo, etc. Por favor, espere mientras se procesa',
    20: 'El pedido ha sido devuelto',
    beenReturned: ' Ver reembolsos >',
    30: 'Su artículo ha sido enviado. Consulte el paquete en el que se encuentra: ',
    43: 'Su solicitud de devolución ha sido cancelada',
    44: 'Su solicitud de cambio ha sido cancelada',
    49: 'Extensión de almacenamiento no pagada. El artículo se considera abandonado voluntariamente.',
  },
  expressNo: 'Número de seguimiento: ',
}
